import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";

ko.bindingHandlers.productpriceselector = {
    init: function(elt, va, allbindings, model, context) {
        var model = {
            prices: ko.observableArray([]),
            choose_price: function(ui, ev) {
                var price = ui.value;
                var current_value = allbindings().pricefield;
                $.each(price, function(key, value) {
                    if (ko.isObservable(current_value[key])) {
                        current_value[key](value);
                    } else {
                        current_value[key] = value;
                    }
                });
            }
        }
        $(elt).data("pps-model", model);
        var cc = context.createChildContext(model);
        ko.applyBindingsToDescendants(cc, elt);
        return { "controlsDescendantBindings": true };
    },
    update: function(elt, va, allbindings) {
        var product_id = ko.unwrap(va());
        var model = $(elt).data("pps-model");
        const pricing_fields = ["selling_price1", "selling_price2", "selling_price3", "cost_price", "price_names"];
        if (product_id) {
            uly.api.start()
                .follow("uly:data")
                .follow("uly:product")
                .follow("find", {
                    "rel":ko.unwrap(product_id),
                    "fields": pricing_fields
                }).done(function(entity) {
                    var new_prices = [];
                    var price_names = {};
                    pricing_fields.forEach((val, i) => {
                        if (entity.price_names[i]) {
                            price_names[val] = entity.price_names[i]
                        }
                    });

                    if (entity.selling_price1) {
                        new_prices.push({
                            "desc": price_names.selling_price1, //RF Price",
                            "display": entity.selling_price1.formatted,
                            "value": entity.selling_price1
                        });
                    }
                    if (entity.selling_price2) {
                        new_prices.push({
                            "desc": price_names.selling_price2, //"OS Price",
                            "display": entity.selling_price2.formatted,
                            "value": entity.selling_price2
                        });
                    }
                    if (entity.selling_price3) {
                        new_prices.push({
                            "desc": price_names.selling_price3, //"TS Price",
                            "display": entity.selling_price3.formatted,
                            "value": entity.selling_price3
                        });
                    }
                    model.prices(new_prices);
                }).fail(function(error) {
                    console.error("Fetcher failed:", error);
                });
        }
    }
};
